import { render, staticRenderFns } from "./accountcard.vue?vue&type=template&id=6dbe2bee&scoped=true"
import script from "./accountcard.vue?vue&type=script&lang=js"
export * from "./accountcard.vue?vue&type=script&lang=js"
import style0 from "./accountcard.vue?vue&type=style&index=0&id=6dbe2bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbe2bee",
  null
  
)

export default component.exports